// src/pages/LoginPage.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function LoginPage({ enterpriseId }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();
  const emailRef = useRef(null);

  useEffect(() => {
    if (emailRef.current) {
      emailRef.current.focus();
    }
  }, []);

  const emailRegex = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
  const passwordRegex = /^[A-Za-z0-9]{4,50}$/;

  const isEmailValid = (value) => emailRegex.test(value.trim());
  const isPasswordValid = (value) => passwordRegex.test(value);

  const isFormValid = () => isEmailValid(email) && isPasswordValid(password);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!isFormValid()) {
      setErrorMsg("Пожалуйста, проверьте правильность введенных данных.");
      return;
    }

    try {
      const response = await fetch("http://qcan-dev.smart-era.com:8001/auth/v1/user/login", {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error("Неверный email или пароль.");
      }

      const data = await response.json();

      if (data.access_token) {
        // Сохраняем токены и, возможно, информацию о времени истечения
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("refresh_token", data.refresh_token);
        localStorage.setItem("access_expiration_time", data.access_expiration_time);
        localStorage.setItem("user_email", email);
        // Перенаправляем пользователя в защищенную часть приложения.
        // Если enterpriseId фиксированный, можно задать его здесь или использовать из data
        const enterpriseIdFixed = '019136dc-c286-7232-94ae-a1b4d79c3887';
        navigate(`/${enterpriseIdFixed}`);
      }
    } catch (error) {
      setErrorMsg(error.message);
    }
  };

  const handleForgotPassword = () => {
    navigate(`/${enterpriseId}/forgot-password`);
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", justifyContent: "center", alignItems: "center", background: "#f0f0f0" }}>
      <form onSubmit={handleSubmit} style={{ background: "#fff", padding: "2rem", borderRadius: "8px", boxShadow: "0 0 10px rgba(0,0,0,0.1)", width: "300px" }}>
        <h2 style={{ marginBottom: "1.5rem", textAlign: "center" }}>Вход</h2>

        {/* Поле Email */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label htmlFor="email">Email</label>
          <input
            ref={emailRef}
            type="email"
            id="email"
            className="form-control"
            placeholder="Введите email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", padding: "0.5rem" }}
          />
          {!isEmailValid(email) && email.length > 0 && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              Некорректный формат email
            </p>
          )}
        </div>

        {/* Поле Пароль с кнопкой "Показать/Скрыть" */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label htmlFor="password">Пароль</label>
          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              className="form-control"
              placeholder="Введите пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: "100%", padding: "0.5rem", paddingRight: "40px" }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{ position: "absolute", top: "50%", right: "8px", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer" }}
            >
              {showPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {!isPasswordValid(password) && password.length > 0 && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              Пароль должен быть от 4 до 50 символов (латиница/цифры).
            </p>
          )}
        </div>

        {/* Чекбокс «Запомнить меня» */}
        <div className="form-group" style={{ marginBottom: "1rem", display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            style={{ marginRight: "0.5rem" }}
          />
          <label htmlFor="rememberMe" style={{ margin: 0 }}>
            Запомнить меня
          </label>
        </div>

        {/* Кнопка «Забыли пароль?» */}
        <div style={{ textAlign: "right", marginBottom: "1rem" }}>
          <button
            type="button"
            onClick={handleForgotPassword}
            style={{ background: "none", border: "none", color: "#007bff", textDecoration: "underline", cursor: "pointer", padding: 0, fontSize: "0.9rem" }}
          >
            Забыли пароль?
          </button>
        </div>

        {/* Вывод ошибки, если она есть */}
        {errorMsg && (
          <div style={{ color: "red", fontSize: "0.9rem", marginBottom: "1rem", textAlign: "center" }}>
            {errorMsg}
          </div>
        )}

        {/* Кнопка «Войти» */}
        <button
          type="submit"
          disabled={!isFormValid()}
          style={{
            width: "100%",
            padding: "0.5rem",
            backgroundColor: isFormValid() ? "#007bff" : "#cccccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: isFormValid() ? "pointer" : "not-allowed",
          }}
        >
          Войти
        </button>
      </form>
    </div>
  );
}

export default LoginPage;

